import apiClient from '../client';
import type { Admission, CreateAdmissionPayload, NextAdmissionCodesResponse, UpdateAdmissionPayload } from '@/types';

export interface MobileAccountEntry {
  phone_e164: string;
  status:     'active' | 'inactive' | 'blocked';
  deleted_at: string | null;
  updated_at: string;
}
export interface MobileAccessStatus  { phones: string[]; accounts: MobileAccountEntry[]; }
export interface MobileAccessResult  { admission_id: number; enabled: boolean; phones_updated: string[]; accounts: MobileAccountEntry[]; }

export const admissionsApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get<{ data: Admission[], pagination: { total: number } }>('/admissions', { params }).then((r) => r.data),

  getNextCodes: (params?: { branch_name?: string; academic_year?: string }) =>
    apiClient.get<{ data: NextAdmissionCodesResponse }>('/admissions/next-codes', { params })
      .then((r) => r.data.data),

  getById: (id: number) =>
    apiClient.get<{ data: Admission }>(`/admissions/${id}`).then((r) => r.data.data),

  create: (payload: CreateAdmissionPayload) =>
    apiClient.post<{ data: Admission }>('/admissions', payload).then((r) => r.data.data),

  update: (id: number, payload: UpdateAdmissionPayload) =>
    apiClient.put<{ data: Admission }>(`/admissions/${id}`, payload).then((r) => r.data.data),

  remove: (id: number) =>
    apiClient.delete(`/admissions/${id}`),

  promote: (id: number, targetClass: string | number) =>
    apiClient.post<{ data: Admission }>(`/admissions/${id}/promote`, { target_class: targetClass }).then((r) => r.data.data),

  promoteBulk: (studentIds: number[], targetClass: string | number) =>
    apiClient.post<{ data: Admission[] }>('/admissions/promote', { student_ids: studentIds, target_class: targetClass }).then((r) => r.data),

  getClassCounts: () =>
    apiClient.get<{ data: { class_id: number | null; class_name: string; count: number }[] }>('/admissions/stats/class-counts').then((r) => r.data.data),

  getMobileAccess: (id: number) =>
    apiClient.get<{ data: MobileAccessStatus }>(`/admissions/${id}/mobile-access`).then((r) => r.data.data),

  setMobileAccess: (id: number, enabled: boolean) =>
    apiClient.patch<{ data: MobileAccessResult }>(`/admissions/${id}/mobile-access`, { enabled }).then((r) => r.data.data),
};
